"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPunkSeedFromBlockHash = exports.getPseudorandomPart = exports.shiftRightAndCast = exports.getRandomPunkSeed = exports.getPunkData = exports.type2PunkBasic = void 0;
const solidity_1 = require("@ethersproject/solidity");
const bignumber_1 = require("@ethersproject/bignumber");
const image_data_json_1 = require("./image-data.json");
const probability_json_1 = __importDefault(require("./config/probability.json"));
const probs = probability_json_1.default;
const { types, necks, cheekses, faces, beards, mouths, earses, hats, helmets, hairs, teeths, lipses, emotions, eyeses, glasseses, goggleses, noses } = image_data_json_1.images;
const accResource = [necks, cheekses, faces, lipses, emotions, teeths, beards, earses, hats, helmets, hairs, mouths, glasseses, goggleses, eyeses, noses];
exports.type2PunkBasic = [
    { punkType: 0, skinTone: 0 },
    { punkType: 0, skinTone: 1 },
    { punkType: 0, skinTone: 2 },
    { punkType: 0, skinTone: 3 },
    { punkType: 1, skinTone: 0 },
    { punkType: 1, skinTone: 1 },
    { punkType: 1, skinTone: 2 },
    { punkType: 1, skinTone: 3 },
    { punkType: 2, skinTone: 6 },
    { punkType: 3, skinTone: 5 },
    { punkType: 4, skinTone: 4 }
];
const shortPunkType = {
    male: "m",
    female: "f",
    alien: "l",
    ape: "p",
    zombie: "z",
};
/**
 * Get encoded part and background information using a Noun seed
 * @param seed The Noun seed
 */
const getPunkData = (seed) => {
    const punkTypeChr = shortPunkType[probability_json_1.default.types[seed.punkType]];
    return {
        parts: [
            types[exports.type2PunkBasic.findIndex((acc) => acc.punkType == seed.punkType && acc.skinTone == seed.skinTone)],
            ...seed.accessories.map(acc => accResource[acc.accType][acc.accId])
            // bodies[seed.body],
            // accessories[seed.accessory],
            // heads[seed.head],
            // glasses[seed.glasses],
        ],
        //    background: bgcolors[seed.background],
    };
};
exports.getPunkData = getPunkData;
/**
 * Generate a random Noun seed
 * @param seed The Noun seed
 */
const pickRandom = (possibilities) => {
    const accumulated = [...possibilities];
    for (let i = 1; i < accumulated.length; i++)
        accumulated[i] = accumulated[i - 1] + possibilities[i];
    const max = accumulated[accumulated.length - 1];
    const randomness = Math.random() * max;
    return accumulated.findIndex((val) => val > randomness);
};
const groupByExclusive = (_accs, exclusive_groups) => {
    const accs = [..._accs];
    const res = [];
    exclusive_groups.forEach((exc, index) => {
        const group = exc.reduce((total, item) => {
            const idx = accs.indexOf(item);
            if (idx < 0)
                return total;
            accs.splice(idx, 1);
            total.push(item);
            return total;
        }, []);
        res.push(group);
        return res;
    }, []);
    return res.concat(accs.map((item) => [item]));
};
const getRandomPunkSeed = () => {
    const typeProbabilities = Object.values(probs.probabilities).map((probObj) => Math.floor(probObj.probability * 1000));
    const punkType = pickRandom(typeProbabilities);
    const punkTypeName = probability_json_1.default.types[punkType];
    const skinTone = pickRandom(probs.probabilities[punkTypeName].skin);
    const availableAccs = probs.probabilities[punkTypeName].accessories;
    const groupedAccs = groupByExclusive(availableAccs, probs.exclusive_groups);
    const accCount = pickRandom(probs.accessory_count_probabbilities.slice(0, groupedAccs.length));
    const countPerGroup = groupedAccs.map((group) => {
        return group
            .map((item) => accResource[Object.keys(probs.acc_types).indexOf(item)].length)
            .reduce((sum, val) => sum + val, 0);
    });
    const selectedGroups = [];
    for (let i = 0; i < accCount; i++) {
        const selectedGroup = pickRandom(countPerGroup);
        selectedGroups.push(selectedGroup);
        countPerGroup[selectedGroup] = 0;
    }
    const accessories = [];
    for (let i in selectedGroups) {
        const currentGroup = groupedAccs[selectedGroups[i]];
        const selectedAccIndex = pickRandom(currentGroup.map((item) => accResource[Object.keys(probs.acc_types).indexOf(item)].length));
        const selectedAcc = Object.keys(probs.acc_types).indexOf(currentGroup[selectedAccIndex]);
        accessories.push({ accType: selectedAcc, accId: Math.floor(Math.random() * accResource[selectedAcc].length) });
    }
    return {
        punkType,
        skinTone,
        accessories,
    };
};
exports.getRandomPunkSeed = getRandomPunkSeed;
/**
 * Emulate bitwise right shift and uint cast
 * @param value A Big Number
 * @param shiftAmount The amount to right shift
 * @param uintSize The uint bit size to cast to
 */
const shiftRightAndCast = (value, shiftAmount, uintSize) => {
    const shifted = bignumber_1.BigNumber.from(value).shr(shiftAmount).toHexString();
    return `0x${shifted.substring(shifted.length - uintSize / 4)}`;
};
exports.shiftRightAndCast = shiftRightAndCast;
/**
 * Emulates the NounsSeeder.sol methodology for pseudorandomly selecting a part
 * @param pseudorandomness Hex representation of a number
 * @param partCount The number of parts to pseudorandomly choose from
 * @param shiftAmount The amount to right shift
 * @param uintSize The size of the unsigned integer
 */
const getPseudorandomPart = (pseudorandomness, partCount, shiftAmount, uintSize = 48) => {
    const hex = (0, exports.shiftRightAndCast)(pseudorandomness, shiftAmount, uintSize);
    return bignumber_1.BigNumber.from(hex).mod(partCount).toNumber();
};
exports.getPseudorandomPart = getPseudorandomPart;
/**
 * Emulates the NounsSeeder.sol methodology for generating a Noun seed
 * @param nounId The Noun tokenId used to create pseudorandomness
 * @param blockHash The block hash use to create pseudorandomness
 */
const getPunkSeedFromBlockHash = (punkId, blockHash) => {
    const pseudorandomness = (0, solidity_1.keccak256)(['bytes32', 'uint256'], [blockHash, punkId]);
    return (0, exports.getRandomPunkSeed)();
};
exports.getPunkSeedFromBlockHash = getPunkSeedFromBlockHash;
